var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.271467 6.9999C0.271467 3.13383 3.40551 -4.631e-07 7.27157 -2.94109e-07C9.35178 -2.0318e-07 11.2148 0.91113 12.4958 2.35209L12.4958 1.1204C12.4958 0.774045 12.7766 0.493425 13.1228 0.493425L13.3724 0.493425C13.7188 0.493425 13.9994 0.774253 13.9994 1.1204L13.9994 4.6087C13.9994 4.61119 14 4.61327 14 4.61577L14 4.8654C14 5.03868 13.9295 5.19573 13.8159 5.3091C13.7023 5.42268 13.5457 5.49299 13.3724 5.49299L13.1228 5.49299C13.1207 5.49299 13.1188 5.49237 13.117 5.49237L9.62741 5.49237C9.28105 5.49237 9.00043 5.21154 9.00043 4.86539L9.00043 4.61577C9.00043 4.26942 9.28126 3.9888 9.62741 3.9888L11.8299 3.9888C10.8464 2.49999 9.16269 1.51501 7.24474 1.51501C4.2066 1.51501 1.74363 3.97798 1.74363 7.01612C1.74363 10.0543 4.20659 12.5172 7.24474 12.5172C9.61409 12.5172 11.6275 11.0166 12.402 8.91597C12.4153 8.93074 12.4311 8.94343 12.4453 8.95779C12.5528 8.81592 12.7215 8.72293 12.9131 8.72293L13.1475 8.72293C13.4729 8.72293 13.7366 8.9867 13.7366 9.31205L13.7366 9.53775C13.7531 9.54087 13.7695 9.54482 13.7859 9.54794C13.7599 9.6143 13.7287 9.67816 13.7009 9.74348C13.6919 9.76886 13.6813 9.79299 13.669 9.8165C12.5842 12.2772 10.1333 14 7.27136 14C3.40551 14 0.271467 10.8658 0.271467 6.9999Z",
    fill: "#121417"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reload-icon.95c6eca466dda4e8445f9b934530ed92.svg";
export { ForwardRef as ReactComponent };